import Logo from "../../../assets/images/club-car-connect-logo.png";
import CustomizedInputs from "commonComponents/FormElement/TextField";
import CustomizedButtons from "commonComponents/Button";
import {
  Container,
  PageTitle,
  InputBoxWrapper,
  Wrapper,
} from "../UserAuthStyled";
import modal1 from "../../../assets/images/modal1.png";
import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { API_STATUSES } from "redux/_helpers/statuses";

// functional imports
import { useNavigate, useParams } from "react-router-dom";
// modal imports
//  material UI imports starts
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
// redux imports starts
import { useDispatch } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useTranslation } from "react-i18next";

// redux imports ends
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  flexDirection: "column",
};

export const ResetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { t } = useTranslation();
 
  // modal design starts
  const [openPasswordChangeSuccessModal, setOpenPasswordChangeSuccessModal] = React.useState(false);
  const [openPasswordErrorModal, setOpenPasswordErrorModal] = React.useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [passwordErrorGoToLogin, setPasswordErrorGoToLogin] = React.useState(false);

  const {
    resetPasswordStatus,
    resetPasswordData
  } = useSelector((state) => state.commonReducers) || [];

  useEffect(() => {
    if (Object.keys(resetPasswordStatus).length > 0) {
      if (resetPasswordStatus === API_STATUSES.IDLE) {
        ; // do nothing
      }
      else if (resetPasswordStatus === API_STATUSES.REQUEST) {
        // disable submit button
      }
      else if (resetPasswordStatus === API_STATUSES.SUCCESS) {
        setOpenPasswordChangeSuccessModal(true);
      }
      else {
        setPasswordErrorMessage("The reset request has expired or there was another error. Try requesting another password reset.");
        setPasswordErrorGoToLogin(true);
        setOpenPasswordErrorModal(true);
      }

    }

  }, [resetPasswordStatus]);

  const handleClick = async (e) => {
    e.preventDefault();

    if (newPassword && confirmPassword && (newPassword === confirmPassword) && (newPassword.length > 7)) {
      dispatch(COMMON_SERVICES.resetPasswordServices(confirmPassword, params.passwordResetToken));
      // see resetPasswordData
    } else {
      setPasswordErrorMessage("The passwords must match and be at least 8 characters long.");
      setPasswordErrorGoToLogin(false);
      setOpenPasswordErrorModal(true);
    }
  };

  const handleClosePasswordChangeSuccessModal = () => setOpenPasswordChangeSuccessModal(false);
  const handleClosePasswordErrorModal = () => setOpenPasswordErrorModal(false);

  return (
    <Container>
      <img src={Logo} alt="logo" className="logo" />
      <Wrapper>
        <PageTitle>Reset Password</PageTitle>
        <form onSubmit={handleClick}>
          <InputBoxWrapper>
            <CustomizedInputs
              id="new_password"
              label={t("New_password")}
              type="password"
              htmlFor="new_password"
              placeholder="Enter new password"
              handelChange={(e) => setNewPassword(e.target.value)}
            />
          </InputBoxWrapper>
          <InputBoxWrapper>
            <CustomizedInputs
              id="confirm_new_password"
              label={t("Confirm_new_password")}
              type="password"
              htmlFor="confirm_new_password"
              placeholder="Re-enter new password"
              handelChange={(e) => setConfirmPassword(e.target.value)}
            />
          </InputBoxWrapper>

          <CustomizedButtons title="Submit" type="submit" />
        </form>
      </Wrapper>

      {/* PasswordChangeSuccessModal */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openPasswordChangeSuccessModal}
        onClose={handleClosePasswordChangeSuccessModal}
        // closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openPasswordChangeSuccessModal}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              <img src={modal1} alt="" />
            </Typography>
            <Typography
              style={{ textAlign: "center" }}
              id="transition-modal-description"
              sx={{ mt: 2 }}
            >
              Your password has been changed.
            </Typography>
            <Button
              variant="contained"
              style={{
                marginTop: "1.5rem",
                borderRadius: "1rem",
                backgroundColor: "#82DBCF",
                color: "black",
                fontSize: "14px",
                fontWeight: "500",
              }}
              className="button-Modal"
              onClick={() => navigate("/")}
            >
              Proceed to Login
            </Button>
          </Box>
        </Fade>
      </Modal>

      {/* PasswordErrorModal */}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openPasswordErrorModal}
        onClose={handleClosePasswordErrorModal}
        // closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openPasswordErrorModal}>
          <Box sx={style}>

            <Typography
              style={{ textAlign: "center" }}
              id="transition-modal-description"
              sx={{ mt: 2 }}
            >
              {passwordErrorMessage}
            </Typography>
            <Button
              variant="contained"
              style={{
                marginTop: "1.5rem",
                borderRadius: "1rem",
                backgroundColor: "#82DBCF",
                color: "black",
                fontSize: "14px",
                fontWeight: "500",
              }}
              className="button-Modal"
              onClick={() => (passwordErrorGoToLogin) ? navigate("/") : window.location.reload()}
            >
              {(passwordErrorGoToLogin) ? "Proceed to Login" : "Try Again"}
            </Button>
          </Box>
        </Fade>
      </Modal>

    </Container>
  );
};
